export const Logo = ({ className = "h-9 w-9" }) => (
  <img
    src="/app-icon.png"
    alt="FUNZ app logo"
    data-testid="funz-logo"
    className={`rounded-[24%] object-cover ${className}`}
  />
);
